import { useTheme } from '@mui/material';
import CustomSmartContractArchitectureIcon from '../../../public/svg/icons/scdServices/customSmartContractArchitecture.svg';
import DefiProtocolDevelopmentIcon from '../../../public/svg/icons/scdServices/defiProtocolDevelopment.svg';
import GasOptimizationPerformanceIcon from '../../../public/svg/icons/scdServices/gasOptimizationPerformance.svg';
import MultiChainDeploymentIcon from '../../../public/svg/icons/scdServices/multiChainDeployment.svg';
import NftAndTokenContractsIcon from '../../../public/svg/icons/scdServices/nftAndTokenContracts.svg';

export const SmartContractDevelopmentServicesData = {
  mainText: 'Smart contract development made to measure',
  description: `From automated payment systems to complex DeFi protocols, we develop smart contracts that handle real-world complexity with enterprise-grade reliability. Our focus is on delivering production-ready code that your business can depend on, whether you're processing millions in transactions or managing intricate governance systems.`,
};

export const AccordionData = () => {
  const theme = useTheme();
  return [
    {
      iconSvg: CustomSmartContractArchitectureIcon,
      iconSvgAlt: 'custom-smart-contract-architecture',
      title: 'Custom Smart Contract Architecture',
      description:
        'We architect smart contracts that solve real business problems, not just demonstrate blockchain capabilities. Every solution is custom-built for your specific requirements, gas-optimized for cost efficiency, and security-audited to protect your users and reputation.<br /><b>Capabilities:</b><br />' +
        `<ul>` +
        `<li>Multi-signature wallets & treasuries</li>` +
        `<li>Automated escrow systems</li>` +
        `<li>Governance & DAO infrastructure</li>` +
        `<li>Cross-chain bridge protocols</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },
    {
      iconSvg: DefiProtocolDevelopmentIcon,
      iconSvgAlt: 'defi-protocol-development',
      title: 'DeFi Protocol Development',
      description:
        'From AMMs to lending protocols, we build DeFi infrastructure that handles real trading volume without breaking. Proven track record with $100M+ protocols.<br /><b>Capabilities:</b><br />' +
        `<ul>` +
        `<li>Automated market makers (AMMs)</li>` +
        `<li>Lending & borrowing protocols</li>` +
        `<li>Yield farming mechanisms</li>` +
        `<li>Liquidity mining systems</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },
    {
      iconSvg: NftAndTokenContractsIcon,
      iconSvgAlt: 'nft-and-token-contracts',
      title: 'NFT & Token Contracts',
      description:
        'Beyond simple ERC-721s. We build advanced NFT systems with dynamic metadata, royalties, fractionalization, and cross-platform compatibility.<br /><b>Capabilities:</b><br />' +
        `<ul>` +
        `<li>Dynamic & programmable NFTs</li>` +
        `<li>On-chain royalty enforcement</li>` +
        `<li>Fractionalization protocols</li>` +
        `<li>Gaming asset management</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },
    {
      iconSvg: GasOptimizationPerformanceIcon,
      iconSvgAlt: 'gas-optimization-performance',
      title: 'Gas Optimization & Performance',
      description:
        'High gas costs kill user adoption. Our optimization typically reduces gas consumption by 40-60% (depending on the case) while maintaining functionality and security.<br /><b>Capabilities:</b><br />' +
        `<ul>` +
        `<li>Assembly-level optimization</li>` +
        `<li>Storage slot packing</li>` +
        `<li>Proxy pattern implementation</li>` +
        `<li>Batch transaction systems</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },
    {
      iconSvg: MultiChainDeploymentIcon,
      iconSvgAlt: 'multi-chain-deployment',
      title: 'Multi-Chain Deployment',
      description:
        'Deploy across 15+ blockchain networks. We handle the technical complexity so your dApp can be chain-agnostic while remaining performant.<br /><b>Capabilities:</b><br />' +
        `<ul>` +
        `<li>Ethereum & Layer 2 solutions</li>` +
        `<li>Solana, Polygon, XRPL, BSC, Avalanche, and more</li>` +
        `<li>Cross-chain messaging</li>` +
        `<li>Universal contract standards</li>` +
        `</ul>`,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },
  ];
};
